import { Action } from 'redux';

export const PREF_SET_GENERAL_RUBY = 'PREF_SET_GENERAL_RUBY';
export const PREF_SET_FONT_SIZE = 'PREF_SET_FONT_SIZE';
export const PREF_SET_FONT_FAMILY = 'PREF_SET_FONT_FAMILY';
export const PREF_SET_LINE_HEIGHT = 'PREF_SET_LINE_HEIGHT';
export const PREF_SET_PADDING = 'PREF_SET_PADDING';
export const PREF_SET_COLOR_SCHEME = 'PREF_SET_COLOR_SCHEME';
export const PREF_SET_CUSTOM_PAGE_COLOR_INDEX = 'PREF_SET_CUSTOM_PAGE_COLOR_INDEX';
export const PREF_SET_ENABLE_COLORING_OF_PAGES = 'PREF_SET_COLORING_OF_PAGES';
export const PREF_SET_CONTENT_FEATURE_FLAG = 'PREF_SET_CONTENT_FEATURE_FLAG';
export const PREF_SET_USER_NAME = 'PREF_SET_USER_NAME';
export const PREF_SET_TTS_TRACKING = 'PREF_SET_TTS_TRACKING';

export enum FontFamily {
  Textbook,
  Serif,
  SansSerif,
}

export enum ColorScheme {
  Scheme1 = '1',
  Scheme2 = '2',
  Scheme3 = '3',
  Scheme4 = '4',
  Scheme5 = '5',
  Scheme6 = '6',
  UserCustomColor = 'user-custom-color',
}

export interface CustomPageColorIndex {
  backgroundColorIndex: number;
  textColorIndex: number;
}

interface SetVisibilityAction extends Action {
  readonly type: typeof PREF_SET_GENERAL_RUBY;
  readonly visible: boolean;
}
interface SetSizeAction extends Action {
  readonly type: typeof PREF_SET_FONT_SIZE | typeof PREF_SET_LINE_HEIGHT | typeof PREF_SET_PADDING;
  readonly size: number;
}
interface SetFontFamilyAction extends Action {
  readonly type: typeof PREF_SET_FONT_FAMILY;
  readonly family: FontFamily;
}
interface SetColorSchemeAction extends Action {
  readonly type: typeof PREF_SET_COLOR_SCHEME;
  readonly colorScheme: ColorScheme;
}
interface SetCustomPageColorIndexAction extends Action {
  readonly type: typeof PREF_SET_CUSTOM_PAGE_COLOR_INDEX;
  readonly customPageColorIndex: CustomPageColorIndex;
}
interface SetEnableColoringOfPageAction extends Action {
  readonly type: typeof PREF_SET_ENABLE_COLORING_OF_PAGES;
  readonly enableColoringOfPages: boolean;
}
interface SetContentFeatureFlagAction extends Action {
  readonly type: typeof PREF_SET_CONTENT_FEATURE_FLAG;
  readonly featureID: string;
  readonly enabled: boolean;
}
interface SetUserNameAction extends Action {
  readonly type: typeof PREF_SET_USER_NAME;
  readonly userName: string;
}
interface SetTTSTrackingAction extends Action {
  readonly type: typeof PREF_SET_TTS_TRACKING;
  readonly ttsTracking: boolean;
}

export type PreferenceAction =
  SetVisibilityAction | SetSizeAction | SetFontFamilyAction | SetColorSchemeAction |
  SetContentFeatureFlagAction | SetEnableColoringOfPageAction | SetCustomPageColorIndexAction |
  SetUserNameAction | SetTTSTrackingAction;

export function isPreferenceAction(action: Action): action is PreferenceAction {
  switch (action.type) {
    case PREF_SET_GENERAL_RUBY:
    case PREF_SET_FONT_SIZE:
    case PREF_SET_FONT_FAMILY:
    case PREF_SET_LINE_HEIGHT:
    case PREF_SET_PADDING:
    case PREF_SET_COLOR_SCHEME:
    case PREF_SET_CONTENT_FEATURE_FLAG:
    case PREF_SET_ENABLE_COLORING_OF_PAGES:
    case PREF_SET_CUSTOM_PAGE_COLOR_INDEX:
    case PREF_SET_USER_NAME:
    case PREF_SET_TTS_TRACKING:
      return true;
    default:
      return false;
  }
}

export function setGeneralRuby(visible: boolean): SetVisibilityAction {
  return { visible, type: PREF_SET_GENERAL_RUBY };
}
export function setFontSize(size: number): SetSizeAction {
  return { size, type: PREF_SET_FONT_SIZE };
}
export function setFontFamily(family: FontFamily): SetFontFamilyAction {
  return { family, type: PREF_SET_FONT_FAMILY };
}
export function setLineHeight(size: number): SetSizeAction {
  return { size, type: PREF_SET_LINE_HEIGHT };
}
export function setPadding(size: number): SetSizeAction {
  return { size, type: PREF_SET_PADDING };
}

export function setEnableColoringOfPage(enableColoringOfPages: boolean):
  SetEnableColoringOfPageAction {
  return { enableColoringOfPages, type: PREF_SET_ENABLE_COLORING_OF_PAGES };
}

export function setColorScheme(colorScheme: ColorScheme): SetColorSchemeAction {
  return { colorScheme, type: PREF_SET_COLOR_SCHEME };
}

export function setCustomPageColorIndex(customPageColorIndex: CustomPageColorIndex):
  SetCustomPageColorIndexAction {
  return { customPageColorIndex, type: PREF_SET_CUSTOM_PAGE_COLOR_INDEX };
}

export function setContentFeatureFlag(
  featureID: string,
  enabled: boolean,
): SetContentFeatureFlagAction {
  return { featureID, enabled, type: PREF_SET_CONTENT_FEATURE_FLAG };
}

export function setUserName(
  userName: string,
): SetUserNameAction {
  return { userName, type: PREF_SET_USER_NAME };
}

export function setTTSTracking(ttsTracking: boolean): SetTTSTrackingAction {
  return { ttsTracking, type: PREF_SET_TTS_TRACKING };
}
